<template>
  <div class="drug-intruction-detail">
    <div class="drug-intruction-detail-info">
      <div class="drug-intruction-detail-info-title">
        {{ detail.drugName }}
      </div>
      <div class="drug-intruction-detail-info-describe">
        请仔细阅读使用说明书并按说明使用 本制剂仅限本医疗机构使用
      </div>
    </div>
    <detail-item
      :content="detail.name"
      :content2="detail.pingying"
      title="药品名称"
    />
    <detail-item :content="detail.mainComponent" title="主要成份" />
    <detail-item :content="detail.character" title="性状" />
    <detail-item :content="detail.purpose" title="功能主治" />
    <detail-item :content="detail.usage" title="用法用量" />
    <detail-item :content="detail.interaction" title="药物相互作用" />
    <detail-item :content="detail.notes" title="注意" />
    <detail-item :content="detail.spec" title="规格" />
    <detail-item :content="detail.storage" title="贮藏" />
    <detail-item :content="detail.packageName" title="包装" />
    <detail-item :content="detail.expireTimes" title="有效期" />
    <detail-item :content="detail.approvalNumber" title="批准文号" />
    <detail-item :content="detail.hospitalName" title="医院名称" />
    <detail-item :content="detail.address" title="生产地址" />
    <detail-item :content="detail.zipCode" title="邮编" />
    <detail-item :content="detail.phone" title="电话" />
    <detail-item :content="detail.fax" title="传真" />
  </div>
</template>

<script>
import DetailItem from "./DetailItem";

export default {
  components: {
    DetailItem
  },
  data() {
    return {
      detail: {}
    };
  },
  created() {
    const { id } = this.$route.query;
    this.$http
      .post(this.$api.OTHER_DRUG_INTRUCTION_DETAIL, {
        id
      })
      .then(res => {
        this.detail = {
          ...res,
          name: `通用名：${res.drugName}`,
          pingying: res.pinyin ? `汉语拼音：${res.pinyin}` : ""
        };
      });
  }
};
</script>

<style lang="less">
.drug-intruction-detail {
  background: @primary-gray;

  &-info {
    display: table;
    background: white;

    &-title {
      margin-top: 0.75rem;
      font-weight: 450;
      font-size: 1.06rem;
      text-align: center;
    }

    &-describe {
      width: 70%;
      margin: 0.63rem auto;
      color: #999;
      font-size: 0.81rem;
      text-align: center;
    }
  }
}
</style>
